import React from "react";
import Recommended from "./Recommended";
import NewlyAddedStores from "./NewlyAdded";
import MostTrendingStore from "./MostTrending";
import Slider from "./Slider";
import Deals from "./Deals";

function Index() {
  return (
    <div style={{backgroundColor: "aliceblue", paddingTop:"1px"}}>
      <Slider />
      <MostTrendingStore />
      <Deals />
      <Recommended />
      <NewlyAddedStores />
    </div>
  );
}

export default Index;
